import DeleteApplicationConfirmModal from './DeleteApplicationConfirmModal.container';

export default DeleteApplicationConfirmModal;
